<template>
  <section class="relative w-full">
    <!-- Desktop screen version -->
    <div
      class="become-hero-bg-section relative md:block hidden w-full overflow-hidden md:bg-center bg-no-repeat bg-right md:bg-contain h-[480px] md:h-[580px] lg:h-[660px] xl:h-[740px] xl:block"
    >
      <div class="container md:relative absolute top-[120px] xl:top-[158px]">
        <div
          class="border-b-4 border-[#f1d4b5] ml-0.5 md:border-b-[6px] skew-x-[-25deg] w-[106px]"
        />

        <h1
          class="text-[30px] md:text-4xl flex-wrap flex xl:text-[52px] font-OPPO-sans-bold xl:tracking-normal tracking-[-2%] leading-[39px] md:leading-[3rem] xl:leading-[58px] font-normal text-start text-white mt-[47px] mb-0"
        >
          <span>{{ title }} </span>
          &nbsp;
          <span class="lowercase text-primary-500">
            {{ secondaryTitle }}
          </span>
        </h1>
        <p
          class="text-[16px] w-[299px] md:w-[500px] lg:w-[540px] font-OPPO-sans-regular font-normal leading-[normal] text-start text-white pt-[30px] pb-[40px]"
          v-html="description"
        ></p>
        <a
          href="#"
          @click="onClickActive"
          class="py-[13px] px-[22px] no-underline capitalize font-OPPO-sans-bold font-normal text-sm leading-6 bg-white text-[#020202] inline-flex justify-center items-center gap-[10px] rounded-md"
        >
          {{ $t("common.contact_us") }}
        </a>
      </div>
    </div>

    <!-- Mobile Version Banner cover Section-->
    <div
      class="relative block bg-[#191919] lg:hidden md:hidden"
      data-aos="fade-left"
      data-aos-delay="100"
      data-aos-offset="100"
    >
      <img
        class="relative w-full h-[480px] object-cover"
        src="@/assets/images/become-dealer/hero-bg-mobile-img.png"
        alt=""
      />

      <div
        class="container md:relative md:top-0 top-auto bottom-8 md:bottom-auto pt-[30px] pb-[60px]"
      >
        <div
          class="border-b-4 skew-x-[-50deg] border-primary-500 w-[108px] h-1 lg:h-[6px] absolute md:mt-[99px] mb-[31px]"
        ></div>
        <h1
          class="text-[27px] flex font-OPPO-sans-bold mb-0 font-normal w-full leading-[36px] text-white mt-[16px]"
        >
          <span>
            {{ title }}
          </span>
          &nbsp;
          <span class="lowercase text-primary-500">
            {{ secondaryTitle }}
          </span>
        </h1>
        <p
          class="text-[15px] mb-[32px] font-OPPO-sans-regular font-normal w-full leading-[24px] text-start text-white pt-[10px]"
          v-html="description"
        />
        <nuxt-link
          :to="$i18nPath(store.pageLinks['contact-us'])"
          class="py-[13px] px-[22px] no-underline w-full uppercase font-OPPO-sans-bold font-normal text-xs md:text-sm leading-6 bg-white text-[#020202] inline-flex justify-center items-center gap-[10px] rounded-md"
          :prefetch="false"
        >
          {{ $t("common.contact_us") }}
        </nuxt-link>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useMainStore } from "~/store";

const store = useMainStore();

const props = defineProps({
  title: {
    type: String,
    default: null,
  },
  secondaryTitle: {
    type: String,
    default: null,
  },
  description: {
    type: String,
    default: null,
  },
});
function onClickActive() {
  const containerEl = document.getElementById("become-contactus");
  containerEl.scrollIntoView({
    behavior: "smooth",
  });
}
</script>

<style>
.become-hero-bg-section {
  background-image: linear-gradient(
      270deg,
      rgba(0, 0, 0, 0) 14.69%,
      rgba(0, 0, 0, 0.68) 100%
    ),
    url("@/assets/images/become-dealer/hero-bg-img.png");
  background-repeat: no-repeat;
  background-position: center center;
  @apply md:bg-cover;
}
</style>
